import dateService from 'live/services/date'
import i18n from 'live/services/i18n'
import React, { useState } from 'react'
import styled from 'styled-components'
import { PresetType } from '../ModelsConfigTypes'

type PresetListProps = {
    selectedId: string,
    presetList: PresetType[],
    changeSelectedPreset: (value: PresetType) => void
    setShowNewPresetModal: (value: boolean) => void
}

export default function PresetList({
    selectedId,
    presetList,
    changeSelectedPreset,
    setShowNewPresetModal
}: PresetListProps): React.ReactElement {

    const [search, setSearch] = useState(false)
    const [searchValue, setSearchValue] = useState('')

    return (
        <Container>
            <Header>
                <h3>{i18n("Presets")}</h3>
            </Header>
            {search ? (
                <ButtonHeader>
                    <input
                        type="text"
                        value={searchValue}
                        onChange={e => setSearchValue(e.target.value)}
                        placeholder={i18n("Type to search")}
                        autoFocus={true} />
                    <Button onClick={() => setSearch(false)}>
                        <i className="fa fa-close" />
                    </Button>
                </ButtonHeader>
            ) : (
                <ButtonHeader>
                    <Button onClick={() => setShowNewPresetModal(true)} style={{ color: "var(--blue-500)", width: '268px' }}>
                        <i className="fa fa-plus" />
                        <span>{i18n("New Preset")}</span>
                    </Button>
                    <Button onClick={() => setSearch(true)}>
                        <i className="fa fa-search" />
                    </Button>
                </ButtonHeader>
            )
            }
            <List>
                {presetList.map(p => {
                    try {
                        if (searchValue && !p.name.toLowerCase().match(RegExp(searchValue.toLowerCase()))) return
                        
                    } catch (error) {
                      
                    }

                    return (
                        <ListItem key={p.id} onClick={() => changeSelectedPreset(p)}>
                            <Overlay style={{
                                background: p.id === selectedId ? 'transparent' : '',
                                borderLeft: p.id === selectedId ? '4px solid var(--blue-500)' : ''
                            }} />
                            <ItemContent>
                                <h3>{p.name}</h3>
                                <h4>{`${i18n('last updated at ')} ${dateService.formatDateTime(p.updatedAt)
                                    }`}</h4>
                            </ItemContent>
                            {p.active && <i className='fa fa-check' />}
                        </ListItem>
                    )
                })}
            </List>
        </Container>
    )
}

export const Container = styled.div`
    width: 100%;

    box-sizing: border-box;
    box-shadow: 0px 1px 5px rgba(54, 65, 89, 0.15);
`

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    border-bottom: 1px solid ${({ theme }) => theme['gray-dark-bg']};
    padding: 0 15px;

    > h3 {
        font-family: ${({ theme }) => theme['font-semibold']};
        text-transform: uppercase;
        font-size: 14px;
        padding: 14px 0;
    }
`

const ButtonHeader = styled.div`
    width: 100%;
    height: 42px;

    display: flex;
    justify-content: flex-start;
    align-items: center;

    > input {
        width: 272px;
        height: 100%;

        &:focus {
            border: 1px solid ${({ theme }) => theme['gray-dark-bg']};
        }
    }
`

export const Button = styled.button`
    background: var(--gray-200);
    height: 42px;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;

    padding: 6px 20px;
    border: 0px;
    border-bottom: 1px solid ${({ theme }) => theme['gray-dark-bg']};

    font-size: 14px;
    font-weight: 600;

    &:last-child {
        border-left: 1px solid ${({ theme }) => theme['gray-dark-bg']};
    }

    > span {
        margin-left: 8px;
    }
`

const List = styled.ul`
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
`

const ListItem = styled.li`
    background: var(--white);
    position: relative;
    width: 100%;
    height: 49px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    border-bottom: 1px solid ${({ theme }) => theme['gray-dark-bg']};
    padding: 6px 16px;

    &:last-child {
        border: 0px;
    }

    > i {
        font-size: 18px;
        color: var(--green-500);
    }
`

const Overlay = styled.div`
    background: rgba(30, 30, 30, .08);
    position: absolute;
    width: 100%;
    height: 100%;

    margin-left: -16px;

    &:hover {
        background: rgba(55, 163, 239, .2);
        transition: background .15s;
        cursor: pointer;
    }
`

const ItemContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    > h3 {
        color: var(--blue-500);
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        margin: 0;
    }

    > h4 {
        font-size: 12px;
        font-style: italic;
        font-weight: 300;
        line-height: 16px;
        margin: 0;
    }
`
